
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.8672 1.876C19.6306 1.33575 19.1297 1 18.5607 1H1.43942C0.870191 1 0.369523 1.33575 0.13264 1.876C-0.102338 2.41175 -0.0211553 3.02325 0.344763 3.47225C0.345001 3.4725 0.345477 3.473 0.345715 3.47325L7.14318 11.778V18.25C7.14318 18.5265 7.28817 18.7808 7.52053 18.9115C7.62576 18.9708 7.74194 19 7.8574 19C7.99596 19 8.13404 18.9575 8.25356 18.874L12.5389 15.874C12.7377 15.7348 12.8569 15.5008 12.8569 15.25V11.778L19.6554 3.47225C20.021 3.02325 20.1025 2.41175 19.8672 1.876Z"}})])
          )
        }
      }
    